import { SpinResponse } from '@cgs/data-access';
import { CgsEvent } from '@cgs/wge';
import { InterruptStateRule } from './interrupt_state_rule';
import { ResponseHolder } from '../../response_holder';
import { BaseGameState } from '../../states/base_game_state';
import { StopEvent } from '../../events/stop_event';

export class StopRule<TResponse extends SpinResponse> extends InterruptStateRule<TResponse> {
  private _ruleCondition: boolean = false;

  constructor(sourceState: BaseGameState<TResponse>, responseHolder: ResponseHolder<TResponse>) {
    super(sourceState, responseHolder);
  }

  public setActive(active: boolean): void {
    super.setActive(active);
    this._ruleCondition = false;
  }

  protected eventTest(event: CgsEvent): boolean {
    this._ruleCondition = event instanceof StopEvent;
    return this._ruleCondition;
  }

  protected ruleCondition(_responseHolder: ResponseHolder<TResponse>): boolean {
    return this._ruleCondition;
  }
}
